var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"navbar__container"},[_c('BackToLandingPageLink',{attrs:{"id":"header-logo-link"}},[_c('InlineSvg',{staticClass:"navbar__logo",attrs:{"src":_vm.logo,"alt":""}})],1),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }